import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { SectorsAirSimpleListComponent } from "./sectors-air-simple-list.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
    BookingTravellerTicketServiceModule
} from "libraries/component/booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-ticket/services/booking-traveller-ticket-service.module";
import { DatePipeModule } from "libraries/date/date.module";

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
        BookingTravellerTicketServiceModule,
        DatePipeModule,
    ],
    exports: [SectorsAirSimpleListComponent],
    declarations: [SectorsAirSimpleListComponent],
})
export class SectorsAirSimpleListModule {}
